import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portfolio16',
  templateUrl: './portfolio16.component.html',
  styleUrls: ['./portfolio16.component.css'],
  standalone: false,
})
export class Portfolio16Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
